var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraVideoX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C2.34315 5 1 6.34315 1 8V16C1 17.6569 2.34315 19 4 19H14C15.6528 19 16.9935 17.6634 17 16.0121L21.6218 17.9265C22.1321 18.1379 22.717 17.8956 22.9284 17.3853C22.9935 17.2282 23.0156 17.0639 23 16.9057V7.09432C23.0156 6.93608 22.9935 6.77182 22.9284 6.61465C22.717 6.10441 22.1321 5.86211 21.6218 6.07346L17 8C17 6.34315 15.6569 5 14 5H4ZM4 7C3.44772 7 3 7.44772 3 8V16C3 16.5523 3.44772 17 4 17H14C14.5523 17 15 16.5523 15 16V8C15 7.44772 14.5523 7 14 7H4ZM21 8.49581V15.5042L17 13.8473V10.1527L21 8.49581Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraVideoX2);
export default __webpack_public_path__ + "static/media/CameraVideoX2.b5614532140260d0bc24ee25f29a0784.svg";
export { ForwardRef as ReactComponent };